import { render, staticRenderFns } from "./ExamViewDialog.vue?vue&type=template&id=5781f1f2&scoped=true"
import script from "./ExamViewDialog.vue?vue&type=script&lang=js"
export * from "./ExamViewDialog.vue?vue&type=script&lang=js"
import style0 from "./ExamViewDialog.vue?vue&type=style&index=0&id=5781f1f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5781f1f2",
  null
  
)

export default component.exports